// Keep in sync with the trail-system/list refetchInterval in providers/TrailSystem and TRAIL_DATA_UPDATE_MINUTE in
// flowfeed-admin-ui's TrailDataUpdateBar.
export const MINUTE_TO_REFETCH = 21

export const calculateMinutesSinceLastUpdate = (now: Date = new Date()) => {
  const thisMinute = now.getMinutes()
  return thisMinute >= MINUTE_TO_REFETCH ? thisMinute - MINUTE_TO_REFETCH : 60 - MINUTE_TO_REFETCH + thisMinute
}

export const calculateMinutesUntilNextUpdate = (now: Date = new Date()) => {
  const thisMinute = now.getMinutes()
  return thisMinute >= MINUTE_TO_REFETCH ? 60 - thisMinute + MINUTE_TO_REFETCH : MINUTE_TO_REFETCH - thisMinute
}
